import React, { useState,useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GlobalContext = React.createContext();


const GlobalContextProvider = (props) => {
    let location = useLocation();
    const [userName, setUserName] = useState('');
    const [loggedIn, setLoggedIn] = useState(false);
    
    useEffect(() => {
      console.log('location isss', location)
    }, [location])
    

    // const getUserInfo = (pageNumber=1,pageSize=1000)=>{
    //   console.log('running global user info')
    //   return new Promise((resolve, reject) => {
    //     addAdminDataWithToken(`admin/is_login.php`,{},
    //       (err,result)=>{
    //         console.log('userinfo',result)
    //         if(!err && result[0]?.error != 1 ){
    //           setGlobalUserInfo(result[0])
    //           resolve();
    //         }else{
    //           console.log('error',err)
    //         }
            
    //       }
    //     )
    //   })
    // }

    // useEffect(() => {
    //   getUserInfo()
    //   .then(()=>setUserInfoLoading(false))

    //   return () => {
    //     setGlobalUserInfo([]);
    //     setUserInfoLoading(false);
    //   }
    // }, [userName])

    


  return (
    <GlobalContext.Provider value={{loggedIn,setLoggedIn,userName,setUserName}}>
      {props.children}
    </GlobalContext.Provider>
  )
}

export {GlobalContext,GlobalContextProvider };